// extracted by mini-css-extract-plugin
module.exports = {"title":"title__2bgfm","subtitle":"subtitle__150GV","arrow":"arrow__2Pfu9","value":"value__37CEN","arrowWrapper":"arrowWrapper__xaPn-"};